import type { AdminAuthorization, Authorization, DataResponse } from "@/types";
import { api } from "../api";

export const authorizationService = {
  /** List the current user's cached delegated authorizations. */
  list: () => api.get<DataResponse<Authorization[]>>("/authorizations"),

  /** Revoke the current user's authorization for a purpose (e.g. "data_sync"). */
  revoke: (purpose: string) => api.delete<DataResponse<boolean>>(`/authorizations/${purpose}`),

  /** Admin: list all authorizations across the organization. */
  listAll: () => api.get<DataResponse<AdminAuthorization[]>>("/authorizations/all"),
};
